import React from "react";

import { convertCreoleToHTML } from "./helper";

interface ICreole {
  text: string;
  options?: any;
}
const Creole: React.FC<ICreole> = ({ text, options = {} }) => {
  const convertedText = convertCreoleToHTML(text);
  return <div dangerouslySetInnerHTML={{ __html: convertedText }} />;
};
export default Creole;
